export default __webpack_public_path__ + "static/media/icon-search-primary.a53c4abf.svg";